export default __webpack_public_path__ + "static/media/star.e7df65c5.svg";